import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { cleanupRequestStatus, userGetBillings } from 'features/billingsV2Slice'
import { Box, Typography } from '@mui/joy'
import { formatMoney } from 'utils/helpers'
import { BILLING_STATUS } from 'utils/config'
import routes from 'routes'
import Breadcrumbs from 'components/Breadcrumbs'
import usePagination from 'hooks/usePagination'
import FiltersWrapper from 'components/tables/FiltersWrapper'
import MainLayout from 'components/templates/MainLayout'
import PageLoader from 'components/PageLoader'
import EnchantedTable from 'components/tables/EnchantedTable'

const getHeaders = () => [
  {
    label: 'Nr',
    propName: 'lp',
    type: 'route',
    route: routes.userBillingsV2Details,
    routeReplace: ':billingId',
  },
  { label: 'Data dodania', propName: 'createdAt', type: 'date' },
  {
    label: 'Ilość zadań',
    propName: 'computed2',
    type: 'computed',
    fn: (billing) => <Typography level="body-xs">{billing.taskIds.length}</Typography>,
  },
  {
    label: 'Wynagrodzenie brutto',
    propName: 'computed1',
    type: 'computed',
    fn: (billing) => <Typography level="body-xs">{formatMoney(billing.totalAmount)}</Typography>,
  },
  { label: 'Status', propName: 'status', type: 'status', statusObj: BILLING_STATUS },
]

const UserBillingsV2View = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const pagination = usePagination()

  const { billings, loading } = useSelector((s) => s.billingsV2)

  useEffect(() => {
    dispatch(userGetBillings())
    return () => dispatch(cleanupRequestStatus())
  }, [dispatch])

  if (loading)
    return (
      <MainLayout>
        <PageLoader />
      </MainLayout>
    )

  return (
    <MainLayout>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Breadcrumbs items={[{ label: 'Rozliczenia' }]} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Moje rozliczenia
        </Typography>
      </Box>

      <FiltersWrapper />

      <EnchantedTable
        headers={getHeaders()}
        data={billings.data}
        offset={(pagination.values.currentPage - 1) * pagination.values.perPage}
        noDataText="Brak rozliczeń do wyświetlenia."
        actions={[
          {
            label: 'Zobacz rozliczenie',
            func: (billing) => navigate(routes.userBillingsV2Details.replace(':billingId', billing.id)),
          },
        ]}
      />
    </MainLayout>
  )
}

export default UserBillingsV2View
